<template>
  <BasicText>
    Le contrat d’alternance reconversion (CAR) est un dispositif d’accès à la formation et à l’emploi spécifique au travail temporaire, qui vise à permettre la reconversion des salariés intérimaires victimes d’un accident du travail ou d’une maladie professionnelle.
  </BasicText>
  <BasicText>
    C’est un dispositif du Fonds professionnel pour l’emploi dans le travail temporaire (FPETT) dont la gestion administrative est assurée par AKTO.
  </BasicText>
  <BasicText>
    Avant de conclure un contrat d’alternance de reconversion n’hésitez pas à vous rapprocher de votre conseiller pour vous renseigner sur les règles applicables.
  </BasicText>
  <BasicText>
    Pour vous aider dans la compréhension du dispositif et la saisie de la demande, vous trouverez ci-dessous des liens utiles.
  </BasicText>
  <BasicText>
      <ul>
        <li
          v-for="(urlLabel, i) in urlLabels"
          :key="i"
        >
          <BasicLink
            :label="urlLabel.label"
            @link-click="redirectExterne(urlLabel.url)"
          />
        </li>
      </ul>
    </BasicText>

  <WrapperCheckbox
    v-model="validationNotice"
    :alertLabel="meta.validationNotice?.$messageErreurDirty!"
    :readonly
  >
    <BasicText>
      J'ai pris connaissance de la
      <BasicLink
        label="notice"
        @link-click="redirectExterne(urlNotice)"
      />
      comprenant les informations liées au traitement des données à caractère personnel.
    </BasicText>
  </WrapperCheckbox>
</template>

<script setup lang="ts">
  import type { UrlLabel } from '@/features/interface/shared/tools'
import { redirectExterne } from '@/features/shared/tools/url'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { useDemandeCARStore } from '../../useDemandeCARStore'

  const store = useDemandeCARStore()
  const { meta, readonly } = storeToRefs(store)
  const { setupFieldWithKey } = store

  const validationNotice = setupFieldWithKey<boolean>('validationNotice')

  const urlLabels = computed(() => {
    const urlsLabels: UrlLabel[] = []
    urlsLabels.push({
        label: 'Les règles de prise en charge',
        url: 'https://www.akto.fr/regles-de-prise-en-charge-travail-temporaire/))',
      })
      urlsLabels.push({
        label: 'Contrat d’alternance reconversion site AKTO',
        url: 'https://www.akto.fr/envisager-une-reconversion-professionnelle/contrat-alternance-reconversion/'
      })
      urlsLabels.push({
        label: 'Le mode opératoire' ,
        url: 'https://ressourcesstatiques.akto.fr/guide/v2/GuideCar.pdf',
      })
      urlsLabels.push({
        label: 'Modèle Contrat type CAR' ,
        url:  import.meta.env.VITE_RESSOURCES_STATIQUES + '/doc/CAR-contrat-type-TT.pdf'
      })
      urlsLabels.push({
        label: 'Modèle Lettre de mission CDI-I CAR' ,
        url: import.meta.env.VITE_RESSOURCES_STATIQUES + '/doc/CAR-lettre-de-mission-CDI-I.pdf'
      })
    return urlsLabels
  })


  const urlNotice = computed(() => {
    const urlResource = import.meta.env.VITE_RESSOURCES_STATIQUES
    return urlResource + '/notice/NoticeCipiCdpiCar.pdf'
  })
</script>

